module.exports = ".btn-clear {\n  margin: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/buttons/settings-add-btn/settings-add-btn.scss
// module id = ./web/modern/components/buttons/settings-add-btn/settings-add-btn.scss
// module chunks = 0